import { getUniqueKey } from 'utils'

interface UIQueueOptions {
  name?: string
  size?: number
  preRun?: () => void
  interval?: number
  skipAnimationFrame?: boolean
}

interface UIQueueItem {
  run: (item: UIQueueItem) => void
  [key: string]: any
}

export class UIQueue {
  queue: UIQueueItem[]
  size: number
  name: string
  isRunning: boolean
  timer: NodeJS.Timeout | null
  aniTimer: number | null
  preRun?: () => void
  interval?: number
  skipAnimationFrame?: boolean

  constructor(options: UIQueueOptions) {
    const { name, size, preRun, interval, skipAnimationFrame } = options

    this.queue = []
    this.size = size || 10
    this.name = name || getUniqueKey('UIQueue')
    this.isRunning = false
    this.timer = null
    this.aniTimer = null
    this.preRun = preRun
    this.interval = interval
    this.skipAnimationFrame = skipAnimationFrame
  }

  push = (item: UIQueueItem): void => {
    // console.log('--- UIQueue.push : ', this.name, item)
    this.queue.push(item)

    while (this.queue.length > this.size) {
      this.queue.shift()
    }

    if (this.queue.length > 0) {
      this.start()
    }
  }

  start = (): void => {
    if (this.isRunning === true) {
      return
    }
    this.isRunning = true
    if (this.preRun != null) {
      this.preRun()
    }
    this.next()
  }

  next = (): void => {
    if (this.queue.length > 0) {
      const timerInterval = this.interval || 150
      this.timer = setTimeout(() => {
        this.execute()
        this.next()
      }, timerInterval)
    } else {
      this.isRunning = false
    }
  }

  execute = (): void => {
    if (this.queue.length > 0) {
      const item = this.queue.shift()
      if (item != null) {
        // console.log('--- UIQueue.execute : ', this.name, item)
        if (this.skipAnimationFrame === true) {
          item.run(item)
        } else {
          this.aniTimer = requestAnimationFrame(() => {
            item.run(item)
          })
        }
      }
    }
  }

  clear = (): void => {
    if (this.timer != null) {
      clearTimeout(this.timer)
    }
    if (this.aniTimer != null) {
      cancelAnimationFrame(this.aniTimer)
    }
    this.queue = []
    this.isRunning = false
    this.timer = null
    this.aniTimer = null
  }
}
